import React, { useContext } from 'react'
import Button from 'syngenta-react-components/dist/components/Button'
import { GlobalContext } from '../../services/context'

const SignedOrApprovedView = () => {
  const { dispatch } = useContext(GlobalContext)
  return(
    <div className='w100% df jcc'>
      <div className='w50% df fxdrc aic jcc bd1-s-lightgray bdrs-4 fw600 fz24 p20'>
        <p>{'You\'re all set!'}</p>
        <p>Please look out for an email from your reseller for more details. You can now close this window.</p>
        <Button styleType='success' onClick={()=> dispatch({ type: 'GO_TO_DASHBOARD' })}>Back to dashboard</Button>
      </div>
    </div>
  )
}

export default SignedOrApprovedView